import { FieldConfig } from "../../common/forms/Interfaces";
import {
  DATE_PICKER,
  NUMBER,
  SELECT,
  SELECT_WITH_NEW_ITEM,
} from "../../../constants/fields";
import CURRENCY from "../../../constants/currency";

const config = {
  client_id: {
    type: SELECT,
    label: "Client",
    placeholder: "Select Client",
    options: [],
    showSearch: true,
    allowClear: false,
  },
  department_id: {
    type: SELECT,
    label: "Department",
    placeholder: "Select Department",
    options: [],
  },
  creation_date: {
    type: DATE_PICKER,
    label: "Date EPI",
    validationRules: [{ required: true, message: "Please select date EPI!" }],
  },
  means_of_transportation: {
    label: "Vehicle",
    placeholder: "Enter Vehicle",
    validationRules: [{ required: true, message: "Please input vehicle!" }],
  },
  carrier: {
    label: "Carrier",
    placeholder: "Enter Carrier",
    validationRules: [{ required: true, message: "Please input carrier!" }],
  },
  driver: {
    label: "Driver Name",
    placeholder: "Enter Driver Name",
  },
  consignor: {
    label: "Consignor",
    placeholder: "Enter Consignor",
  },
  currency: {
    type: SELECT_WITH_NEW_ITEM,
    label: "Currency",
    placeholder: "Enter Currency",
    options: CURRENCY,
  },
  brutto: {
    type: NUMBER,
    label: "Brutto",
    placeholder: "Enter Brutto",
  },
  cmr: {
    label: "CMR",
    placeholder: "Enter CMR",
    validationRules: [{ required: true, message: "Please input cmr!" }],
  },
  date_cmr: {
    type: DATE_PICKER,
    label: "CMR Date",
    placeholder: "Enter CMR Date",
    validationRules: [{ required: true, message: "Please input cmr date!" }],
  },
  border_checkpoint_name: {
    label: "Departure Customs",
    placeholder: "Enter departure customs!",
  },
  customs_code_and_office_name: {
    label: "Destination Customs",
    placeholder: "Enter Destination Customs",
    validationRules: [
      { required: true, message: "Please input destination customs!" },
    ],
  },
  way: {
    label: "Way",
    placeholder: "Enter Way",
    validationRules: [{ required: true, message: "Please input way!" }],
  },
  note: {
    label: "Note",
    placeholder: "Enter Note",
  },
  invoice: {
    type: NUMBER,
    label: "Invoice",
    placeholder: "Enter Invoice",
  },
  certificate: {
    label: "Certificate Number",
    placeholder: "Enter Certificate Number",
  },
  warranty: {
    type: NUMBER,
    label: "Warranty",
    placeholder: "Enter Warranty",
    validationRules: [{ required: true, message: "Please input warranty!" }],
  },
  measure_code: {
    type: NUMBER,
    label: "Measure Code",
    placeholder: "Enter Measure Code",
  },
  consignment_items: {
    type: NUMBER,
    label: "TNVED",
    placeholder: "Enter TNVED",
    validationRules: [{ required: true, message: "Please input TNVED!" }],
  },
} as { [key: string]: FieldConfig };

export default config;
